/**
 * 吸底按钮（点击滚动到页面最底部）
 * - 始终固定在屏幕右侧显示
 * - 不可拖拽，位置固定
 * - 品牌色渐变背景 + 双向下箭头 + 呼吸光晕动画
 */
interface ScrollToBottomProps {
  /** 距离底部距离 (px)，避免遮挡底部固定栏和 AI 麦克风，默认 200 */
  bottomOffset?: number;
  /** 距离右侧距离 (px)，默认 12 */
  rightOffset?: number;
}

export default function ScrollToBottom({
  bottomOffset = 200,
  rightOffset = 12,
}: ScrollToBottomProps) {
  const handleClick = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
  };

  return (
    <>
      <style>{`
        .scroll-to-bottom-btn {
          animation: stb-breathe 2.4s ease-in-out infinite;
        }
        .scroll-to-bottom-btn:active {
          animation: none;
          transform: scale(0.9);
        }
        @keyframes stb-breathe {
          0%, 100% {
            box-shadow: 0 6px 18px rgba(255,107,53,0.32), 0 2px 6px rgba(0,0,0,0.08);
          }
          50% {
            box-shadow: 0 8px 26px rgba(255,107,53,0.55), 0 3px 10px rgba(0,0,0,0.12);
          }
        }
        @keyframes stb-arrow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(2px); }
        }
        .scroll-to-bottom-btn .stb-arrow {
          animation: stb-arrow 1.4s ease-in-out infinite;
          display: inline-block;
        }
      `}</style>

      <button
        onClick={handleClick}
        aria-label="滚动到底部"
        className="scroll-to-bottom-btn fixed z-30 rounded-full flex items-center justify-center cursor-pointer transition-transform"
        style={{
          right: rightOffset,
          bottom: bottomOffset,
          width: 44,
          height: 44,
          background: "linear-gradient(135deg, #FF6B35 0%, #FF9A5C 100%)",
          border: "1px solid rgba(255,255,255,0.18)",
        }}
      >
        <span className="stb-arrow">
          <i className="ri-arrow-down-s-fill" style={{ fontSize: 26, color: "#fff" }} />
        </span>
      </button>
    </>
  );
}
